import { render, staticRenderFns } from "./gj-required.vue?vue&type=template&id=961489d4&scoped=true&"
import script from "./gj-required.vue?vue&type=script&lang=js&"
export * from "./gj-required.vue?vue&type=script&lang=js&"
import style0 from "./gj-required.vue?vue&type=style&index=0&id=961489d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961489d4",
  null
  
)

export default component.exports